module.exports = __webpack_public_path__ + "img/nocollect.33d242f1.png";